import React, { Fragment, useEffect, useState } from 'react';
import Input from '../bronson/Input';
import {
    filterPlate,
    filterVIN,
    filterFinancialOperation,
} from '../../constants/Filters';
import '../../css/components/vehicleFilters/InputFilters.css';

const Inputfilter = ({
    containerType,
    filterTitle,
    filterCode,
    filters,
    updateFilters,
}) => {
    const [inputValue, setInputValue] = useState(filters[filterCode] || '');
    const [inputIsError] = useState(false);

    useEffect(() => {
        setInputValue(filters[filterCode] != null ? filters[filterCode] : '');
    }, [filterCode, filters]);

    const onClick = () => {
        updateFilters({ ...filters, [filterCode]: inputValue });
    };

    const onChangeInput = value => {
        let valueUppercase = value;
        if (
            filterCode === filterPlate ||
            filterCode === filterVIN ||
            filterCode === filterFinancialOperation
        )
            valueUppercase = value.toUpperCase();
        setInputValue(valueUppercase || '');
        if (containerType === 'advanced')
            updateFilters({ ...filters, [filterCode]: valueUppercase });
    };

    const onKeyPress = event => {
        if (event.key === 'Enter')
            updateFilters({ ...filters, [filterCode]: inputValue });
    };

    const printInput = () => {
        let maxlength = null;
        let inputOptions = {
            id: filterCode,
            type: 'text',
            className: inputIsError === true ? 'is-error' : '',
            isRequired: false,
        };

        if (filterCode === filterPlate) maxlength = 7;
        if (filterCode === filterVIN) maxlength = 17;

        if (maxlength != null)
            inputOptions = { ...inputOptions, maxlength: maxlength };

        if (containerType === 'default')
            inputOptions = {
                ...inputOptions,
                backButton: { type: 'semantic-search' },
            };

        return (
            <Input
                value={inputValue}
                onChange={onChangeInput}
                onKeyPress={onKeyPress}
                options={inputOptions}
                onclickbackbutton={onClick}
            ></Input>
        );
    };

    return (
        <Fragment>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text ">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content c-vehicle-filters__item-content--input"
                aria-hidden="true"
            >
                <div className="c-accordion__content c-accordion__content--max-width">
                    {printInput()}
                </div>
            </div>
        </Fragment>
    );
};

export default Inputfilter;
